// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminStatisticsController from "./admin_statistics_controller"
application.register("admin-statistics", AdminStatisticsController)

import AdminTranslationsController from "./admin_translations_controller"
application.register("admin-translations", AdminTranslationsController)

import AlbumExplorerController from "./album_explorer_controller"
application.register("album-explorer", AlbumExplorerController)

import CartNotificationController from "./cart_notification_controller"
application.register("cart-notification", CartNotificationController)

import MagicboxController from "./magicbox_controller"
application.register("magicbox", MagicboxController)

import PageAnalyticsController from "./page_analytics_controller"
application.register("page-analytics", PageAnalyticsController)

import PaymentMethodsController from "./payment_methods_controller"
application.register("payment-methods", PaymentMethodsController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import PreactController from "./preact_controller"
application.register("preact", PreactController)

import RecaptchaController from "./recaptcha_controller"
application.register("recaptcha", RecaptchaController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import RecordImageController from "./record_image_controller"
application.register("record-image", RecordImageController)

import RecordTabsController from "./record_tabs_controller"
application.register("record-tabs", RecordTabsController)

import RecordsTableController from "./records_table_controller"
application.register("records-table", RecordsTableController)
